import axios from 'axios';

import { ApplicationModule } from 'shared/modules';
import { getBackendUrl } from 'shared/utilities/getBackendUrl';

const getFilename = (contentDisposition?: string) => {
    const fallback = 'task_tracker_archive.xlsx';
    if (!contentDisposition) {
        return fallback;
    }

    const match = contentDisposition.match(/filename="?([^"]+)"?/);

    return match?.[1] || fallback;
};

export const tasksArchiveExportQuery = async function () {
    try {
        const response = await axios({
            method: 'get',
            url: getBackendUrl('/api/task-tracker/tasks/export'),
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${ApplicationModule.accessToken}`,
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
        });

        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');

        link.href = url;
        link.download = getFilename(response.headers['content-disposition']);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return { isSuccess: true };
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 401) {
            ApplicationModule.setAccessToken(null);
        }

        return { isSuccess: false };
    }
};
